import './bootstrap'
import 'cleave.js';
import './phone-type-formatter.al-at-be-bg-ch-cy-cz-de-dk-ee-el-es-fi-fr-gb-hr-hu-ie-is-it-li-lt-lu-lv-me-mk-mt-nl-no-pl-pt-ro-rs-se-si-sk-tr'
import app from './createVue';

app.mount('#app');

